module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }